import { render, staticRenderFns } from "./ProductScorecard.vue?vue&type=template&id=c5f3a2e6&"
import script from "./ProductScorecard.vue?vue&type=script&lang=js&"
export * from "./ProductScorecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports